import { Action } from '@ngrx/store';

export enum AppActionTypes {
  StartLoading = '[App] Start Loading',
  StopLoading = '[App] Stop Loading',
  SetLocaleId = '[App] Set Locale ID',
  Misconfiguration = '[App] Misconfiguration',
  SetWorkflowId = '[App] Set Workflow ID',
}

export class StartLoading implements Action {
  readonly type = AppActionTypes.StartLoading;
}

export class StopLoading implements Action {
  readonly type = AppActionTypes.StopLoading;
}

export class SetLocaleId implements Action {
  readonly type = AppActionTypes.SetLocaleId;

  constructor(public payload: { localeId: string }) {}
}

export class Misconfiguration implements Action {
  readonly type = AppActionTypes.Misconfiguration;
}

export class SetWorkflowId implements Action {
  readonly type = AppActionTypes.SetWorkflowId;
  constructor(public payload: { workflowId: number }) {}
}

export type AppActions =
  | StartLoading
  | StopLoading
  | SetLocaleId
  | Misconfiguration
  | SetWorkflowId;
